import { render, staticRenderFns } from "./space.vue?vue&type=template&id=5092fefe&scoped=true&"
import script from "./space.vue?vue&type=script&lang=js&"
export * from "./space.vue?vue&type=script&lang=js&"
import style0 from "./space.vue?vue&type=style&index=0&id=5092fefe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092fefe",
  null
  
)

export default component.exports